import React, { useState } from "react";
import Box from "@mui/material/Box";
import { SFIconButton } from "../buttons";
import { SFStack } from "../grid";
import useStyled from "../../hooks/useStyled";

const { styled } = useStyled();

const Wrapper = styled("div")(({ theme }) => ({
  position: "relative",
  width: "100%",
}));

const StyledStack = styled(SFStack)(({ theme }) => ({
  padding: theme.spacing(1),
  width: "100%",
}));

const StyledButton = styled(SFIconButton)(({ theme }) => ({
  padding: theme.spacing(1.7),
}));

const SFCollapseMenu = ({
  header,
  children,
  expandIcon = null,
  onExpand=()=>{},
}) => {
  const [expand, setExpand] = useState(false);

  const handleClick = () => {
    !expand && onExpand();
    setExpand((state) => !state);
  };

  return (
    <Wrapper>
      <Box
        sx={{
          position: "absolute",
          width: "100%",
          top: 0,
          overflow: "hidden",
          height: expand ? "auto" : 50,
          borderRadius: "4px",
          zIndex: 1,
          backgroundColor: "rgba(58, 58, 74, 1)",
          boxShadow: "0px 2px 4px 0px rgba(0, 0, 0, 0.20)",
        }}
      >
        <SFStack direction="row" justifyContent={"space-between"}>
          {header}
          {expandIcon && (
            <StyledButton
              onClick={handleClick}
              variant="transparent"
              size="large"
            >
              {expandIcon}
            </StyledButton>
          )}
        </SFStack>
        <StyledStack alignItems={"center"}>{children}</StyledStack>
      </Box>
    </Wrapper>
  );
};

export default SFCollapseMenu;
